import { useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, useColorMode, useDisclosure, useToast } from '@chakra-ui/react';
import { AmplitudeAnalyticsContext } from '../../contexts/useAnalytics';
import { usePapercupsWidget } from '../../hooks/usePapercupsWidget';
import { fetchAllApplications } from '../../redux/applications/actions';
import {
  getApplicationLoadingStatus,
  getApplications,
} from '../../redux/applications/selectors';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { GET_ALL_ACTIVE_PROVIDERS, ZKFETCH_APPLICATION } from '../../utils';
import { getFirebaseIdToken } from '../../utils/utils';
import { HomeDashboard } from './components/dashboard.component';

export const ApplicationsScreen = () => {
  const [allHTTPproviders, setAllHTTPProviders] = useState([]);
  const [zkFetchApplications, setZkFetchApplications] = useState([]);
  const [currentTabIndex, setCurrentTabIndex] = useState(
    document?.referrer?.includes('zkfetch') ? 1 : 0
  );
  const { logEvent, setDashboardVisitCount } = useContext(AmplitudeAnalyticsContext);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    dispatch(fetchAllApplications());
  }, []);

  const applications = useAppSelector(getApplications);
  const applicationLoadingStatus = useAppSelector(getApplicationLoadingStatus);

  usePapercupsWidget();

  const { colorMode } = useColorMode();
  const toast = useToast();

  const fetchAllActiveProviders = useCallback(async () => {
    try {
      const accessToken = await getFirebaseIdToken();
      const response = await fetch(GET_ALL_ACTIVE_PROVIDERS, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      setAllHTTPProviders(data.providers);
    } catch (error) {
      toast({
        title: 'Error',
        description: 'An error occurred while fetching the providers.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  }, []);

  const fetchAllZkFetchApplications = useCallback(async () => {
    try {
      const accessToken = await getFirebaseIdToken();
      const response = await fetch(ZKFETCH_APPLICATION, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();

      setZkFetchApplications(data.applications);
    } catch (error) {
      toast({
        title: 'Error',
        description: 'An error occurred while fetching the applications.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  }, []);

  useEffect(() => {
    fetchAllActiveProviders();
    fetchAllZkFetchApplications();
  }, []);

  useEffect(() => {
    setDashboardVisitCount((prev) => prev + 1);
  }, []);

  const handleTabChange = (index: number) => {
    setCurrentTabIndex(index);
  };

  return (
    <>
      <Box>
        <HomeDashboard />
      </Box>
    </>
  );
};
